

// Generated class FilterTicket_ManagedObject

class FilterTicket_ManagedObject extends MIOManagedObject
{
}
